<template>
    <div class="z-0 flex">
        <span class="text-sm capitalize">{{ data.name }}</span>

        <div class="ml-auto mr-2 flex w-8">
            <VehicleType :data="data.type" />
        </div>
        <span class="rounded-full bg-brand bg-opacity-75 px-3 py-0 text-sm capitalize text-white">
            {{ data.registration }}
        </span>
    </div>
</template>

<script setup>
import VehicleType from '../../../table/cellModules/VehicleType.vue';
// import { MuvalButton } from "@buttons";

defineProps({
    data: {
        type: Object,
        required: true,
    },
});
</script>
